import React, { useCallback, useEffect, useState } from 'react';
import './mouse-emphasize.scss';

export function MouseEmphasize({ children }: { children: JSX.Element }) {
    const [circle, setCircle] = useState<HTMLDivElement | null>(null);

    const trackCursor = (evt: MouseEvent): void => {
        if (!circle) {
            return;
        }
        const rect = document.body.getBoundingClientRect();
        const x = evt.clientX - rect.left;
        const y = evt.clientY - rect.top;
        const newPosX = x - 40;
        const newPosY = y - 40;
        circle.style.transform = `translate3d(${+newPosX}px, ${+newPosY}px, 0)`;
    };

    const callback = useCallback(trackCursor, [trackCursor]);

    useEffect(() => {
        document.addEventListener('click', callback);
        document.addEventListener('mousemove', callback);
        return () => {
            document.removeEventListener('click', callback);
            document.removeEventListener('mousemove', callback);
        };
    }, [callback]);

    return (
        <>
            <div id={'mb__circle'} ref={ref => setCircle(ref)}/>
            {children}
        </>
    );
}
